import { OrganizationKeyName } from "../../../model/Organization";

export const GET_UNASSIGNED_NEWS_LIST_FAIL =
  "SHOP:GET_UNASSIGNED_NEWS_LIST_FAIL";

export const getUnassignedNewsListFailAction = (
  organization: OrganizationKeyName
) => ({
  type: GET_UNASSIGNED_NEWS_LIST_FAIL as typeof GET_UNASSIGNED_NEWS_LIST_FAIL,
  organization,
});

export type GetUnassignedNewsListFailAction = ReturnType<
  typeof getUnassignedNewsListFailAction
>;
